import { Environment, getEnvironment } from "@/shared/env";
import { scrubPidAndAuthHeaders, ScrubbableErrorObject } from "@/shared/logScrubber";
import { AuthFactory } from "@/shared/api/auth";

const annotateLogsWithCurrentUser = () => {
  if (!loggingEnabled() || !DD_LOGS) return;

  const user = AuthFactory.getAuth().getUser();
  DD_LOGS.addLoggerGlobalContext(
    "username",
    user ? user.username : "NO_USER_LOGGED_IN"
  );
};

export function log (message: string, jsonAttributes: object, status: string) {
  if (!loggingEnabled() || !DD_LOGS) return;

  annotateLogsWithCurrentUser();
  DD_LOGS.logger.log(
    message,
    scrubPidAndAuthHeaders(jsonAttributes as ScrubbableErrorObject),
    status);
}

const environment = getEnvironment();

export function loggingEnabled () {
  return environment === Environment.Prod || environment === Environment.ExternalDev;
}

export function getClientToken () {
  switch (environment) {
    case Environment.Prod:
      return "pub9a0cfb59ffaa2c710e39cf12f155d525";
    case Environment.ExternalDev:
      return "puba0e684d67c0475a5ee193e82bd1dc2ea";
    default:
      return "";
  }
}
